/* eslint-disable react/prop-types */
import React from "react";
//Elements
import { Navbar } from "react-bootstrap";
import { Link } from "react-router-dom";
import Logo from "../images/logo.svg"

const NavbarBrand = (props) => {
  return (
    <Navbar.Brand as={Link} to={props.direction}>
     <img src={Logo} className="logo" alt="logo" />
    </Navbar.Brand>
  );
};

export default NavbarBrand;
